import { useMutation } from '@tanstack/react-query';
import type { Coupon, CourseCouponRequest } from './interfaces';
import { edupassClient } from '@/data/@clients';

export const useCourseCoupon = () => {
  const { mutate, isPending } = useMutation<
    { data: Coupon },
    unknown,
    CourseCouponRequest
  >({
    mutationFn: async ({ coupon, courseId }) =>
      edupassClient.get(`coupons/${coupon}/course/${courseId}`),
  });

  return { validateCoupon: mutate, isPending };
};
